import { HttpErrorResponse } from '@angular/common/http';

import { ErrorResponse } from '@elearnio/angular2-jsonapi';

const SECONDS_PER_MINUTE = 60;

export const RATE_LIMIT_STATUS = 429;
export const DEFAULT_RETRY_MINUTES = 5;

// The jsonapi datastore rethrows a raw HttpErrorResponse for non-JSON:API
// bodies (a throttled response) but an ErrorResponse for validation errors,
// so callers cannot assume the error carries a status or headers.
export function isRateLimitError(
  error: HttpErrorResponse | ErrorResponse,
): boolean {
  return (
    error instanceof HttpErrorResponse && error.status === RATE_LIMIT_STATUS
  );
}

export function parseRetryAfterMinutes(error: HttpErrorResponse): number {
  const retryAfter = Number(error.headers.get('Retry-After'));
  if (!Number.isFinite(retryAfter) || retryAfter <= 0) {
    return DEFAULT_RETRY_MINUTES;
  }
  return Math.max(1, Math.ceil(retryAfter / SECONDS_PER_MINUTE));
}
